const mesTemplet = {
    path: 'mesTemplet',
    component: resolve => require(['@/pages/admin/message/mesTemplet.vue'], resolve)
}

export default mesTemplet